import { Box } from "@jewlr/storybook/core"
import React from "react"
import Helmet from "react-helmet"

import ImageBackgroundBanner from "components/landing/image-background-banner"

import Features from "../features"
import WatchCollections from "../watch-collections"

import AboutOurWatches from "./about-our-watches"
import {
  banner as getBanner,
  watchesForMen,
  watchesForWomen,
  features as getFeatures,
  packagedForGifting as getPackagedForGifting,
  shopAllWatches as getShopAllWatches,
  makeItPersonal as getMakeItPersonal,
  watchCollections as getWatchCollections,
} from "./data"
import ShopWatch from "./shop-watch"

const LandingWatches = () => {
  const banner = getBanner()
  const features = getFeatures()
  const packagedForGifting = getPackagedForGifting()
  const shopAllWatches = getShopAllWatches()
  const makeItPersonal = getMakeItPersonal()
  const watchCollections = getWatchCollections()
  return (
    <Box>
      <Helmet>
        <title>About Jewlr Watches</title>
      </Helmet>
      <ImageBackgroundBanner element={banner} firstElement lazyload={false} />
      <Features data={makeItPersonal} descriptionOnTop />
      <WatchCollections data={watchCollections} />
      <Box contain>
        <Features data={features} descriptionOnTop />
      </Box>
      <Features data={packagedForGifting} descriptionOnTop />
      <Box contain>
        <ShopWatch data={watchesForMen} title="Watches For Men" />
        <ShopWatch data={watchesForWomen} title="Watches For Women" />
        <AboutOurWatches />
      </Box>
      <Features data={shopAllWatches} />
    </Box>
  )
}

export default LandingWatches
